import { createContext, useContext, useEffect, useState } from "react";
import api, { apiErr } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (/^\/(firma|hotel|stazione|q|guida|documenti|riconsegna)\//.test(window.location.pathname) || window.location.pathname === "/guida") {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.otp_required) return { ok: true, otp: true, challenge_id: data.challenge_id };
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e, "Credenziali non valide") };
    }
  };

  const verifyOtp = async (challenge_id, code) => {
    try {
      const { data } = await api.post("/auth/verify-otp", { challenge_id, code });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiErr(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    Object.keys(localStorage).filter((k) => k.startsWith("amalfi-express-draft-")).forEach((k) => localStorage.removeItem(k));
    sessionStorage.clear();
    setUser(false);
  };

  const can = (...roles) => !!user && roles.includes(user.role);

  return <AuthContext.Provider value={{ user, login, verifyOtp, logout, can }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
